<template>
    <div v-if="isOpen" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div class="bg-gray-800 p-6 rounded-xl shadow-lg w-96">
        <h3 class="text-lg font-semibold text-white">Two-Factor Authentication</h3>
        <p class="text-gray-300 text-sm mt-2">Enter the 6-digit code from your authenticator app.</p>
  
        <input v-model="verificationCode" type="text" placeholder="Enter Code" 
               class="w-full p-2 rounded bg-gray-600 mt-4 text-center text-lg tracking-widest">
  
        <div class="flex justify-end space-x-2 mt-4">
          <button @click="closeModal" class="bg-gray-500 p-2 rounded-lg hover:bg-gray-600">Cancel</button>
          <button @click="verify2FA" class="bg-green-500 p-2 rounded-lg hover:bg-green-600">Verify</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: '2FAModal',
    props: ["isOpen"],
    data() {
      return {
        verificationCode: "",
      };
    },
    methods: {
      closeModal() {
        this.$emit("close");
      },
      verify2FA() {
        this.$emit("verify", this.verificationCode); 
      },
    },
  };
  </script>
  